import Slider from '../slider';

export default class Home {
    constructor() {
        let slider = new Slider();
        slider.news('.slider-actualites', 5000, 850);
        slider.products('.slider-produits', 850);
        slider.references('.slider-clients', 700);
    }
}